import React from 'react';
import Theme from '../../theme';

interface SVGProps {
  height?: string;
  fill?: string;
  width?: string;
}

const HouseIcon: React.FunctionComponent<SVGProps> = ({
  height = '17px',
  fill = Theme.colors.dark.hexCode,
  width = '18px',
}: SVGProps) => {
  const viewBox = `0 0 ${width} ${height}`.replace(/px/g, '');

  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>Home</title>
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Dashboard_-1-Copy-12" transform="translate(-35.000000, -136.000000)" fill={fill}>
          <g id="Group-12" transform="translate(24.660000, 124.200000)">
            <path
              d="M15.3344299,28.3498979 C14.5698547,28.3487743 14.1621925,28.3352918 13.8445362,28.173501 C13.5397089,28.018143 13.2918813,27.770364 13.1365719,27.46548 C12.9894286,27.176715 12.9649048,26.8135875 12.9608175,26.1754725 L12.96,17.7926058 L11.7567612,18.5145426 C11.3731614,18.744696 10.8756108,18.6203205 10.6454574,18.2367207 C10.4152943,17.8531209 10.5396795,17.3555703 10.9232793,17.1254088 L10.9232793,17.1254088 L14.9863689,14.6875518 L18.102366,12.8101824 C18.329085,12.6736083 18.502911,12.5688672 18.650169,12.4901676 C18.683946,12.4713351 18.718128,12.4537905 18.752796,12.4375419 C18.875673,12.3775371 18.982026,12.3376203 19.091376,12.3135309 C19.321011,12.2629221 19.558989,12.2629221 19.788624,12.3135309 C19.89765,12.3375555 20.00376,12.3773265 20.126232,12.4370721 C20.161548,12.453588 20.196378,12.4714566 20.230722,12.4906617 C20.377818,12.5693046 20.551401,12.6738918 20.777634,12.8101824 L20.777634,12.8101824 L23.889006,14.6847492 L27.956745,17.1254088 C28.340361,17.3555703 28.464777,17.8531209 28.234575,18.2367207 C28.004454,18.6203205 27.506871,18.744696 27.123255,18.5145426 L27.123255,18.5145426 L25.92,17.7925734 L25.92,25.758 C25.92,26.665362 25.92,27.118962 25.74342,27.46548 C25.588143,27.770364 25.340283,28.018143 25.03548,28.173501 C24.688962,28.35 24.235281,28.35 23.328,28.35 Z M19.44,13.9051566 L19.433196,13.908672 L15.8210577,16.0759728 L14.58,16.8237 L14.5804385,26.0797586 C14.5815172,26.3652114 14.5851212,26.548479 14.5966941,26.690148 L14.5966941,26.690148 L14.598549,26.711451 L14.6199087,26.713314 C14.8087764,26.728785 15.0716295,26.73 15.552,26.73 L17.0099014,26.7295743 L17.01,23.49 C17.01,22.2015946 18.0126188,21.1474396 19.2802227,21.0651686 L19.44,21.06 C20.782089,21.06 21.87,22.147911 21.87,23.49 L21.87,23.49 L21.8699014,26.7295743 L23.4982361,26.7299176 C23.8194327,26.7295369 24.0283406,26.7275559 24.1855122,26.7184728 L24.260067,26.713314 L24.281451,26.711451 L24.283314,26.690148 C24.298704,26.501256 24.3,26.238411 24.3,25.758 L24.3,16.8236838 L23.054382,16.0731945 L19.447047,13.9088259 L19.44,13.9051566 Z M19.44,22.68 C18.992637,22.68 18.63,23.042637 18.63,23.49 L18.63,26.73 L20.25,26.73 L20.25,23.49 C20.25,23.042637 19.887363,22.68 19.44,22.68 Z"
              id="Combined-Shape"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default HouseIcon;
